import {
  Box,
  Button,
  Typography,
  Autocomplete,
  TextField,
  CircularProgress,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { formatOrganizationLabel } from "../../utils/organizationLabel";

export default function PurchaseOrderHeader({
  onBack,
  organizations,
  orgsLoading,
  orgsLoadingMore,
  onOrgListScroll,
  selectedOrg,
  orgInputValue,
  onOrgChange,
  onOrgInputChange,
  onUploadCsv,
  uploadCsvDisabled,
}) {
  return (
    <Box sx={{ mb: 3 }}>
      <Button
        startIcon={<ArrowBackIcon />}
        onClick={onBack}
        sx={{ mb: 2, color: "#666" }}
      >
        Back to purchase orders
      </Button>
      <Typography
        variant="h4"
        sx={{ fontWeight: 700, color: "#1a1a1a", mb: 0.5 }}
      >
        Create purchase order
      </Typography>
      <Typography variant="body2" sx={{ color: "#666", mb: 2 }}>
        Select a shop, then add products. Order is created for the
        shop&apos;s primary app user in CREATED status.
      </Typography>
      <Box
        sx={{
          display: "flex",
          gap: 2,
          flexWrap: "wrap",
          alignItems: "flex-start",
        }}
      >
      <Autocomplete
        loading={orgsLoading}
        options={organizations}
        filterOptions={(options) => options}
        inputValue={orgInputValue}
        getOptionLabel={(o) => formatOrganizationLabel(o)}
        isOptionEqualToValue={(a, b) => a?.id === b?.id}
        value={selectedOrg}
        onChange={onOrgChange}
        onInputChange={onOrgInputChange}
        sx={{
          flex: "1 1 520px",
          minWidth: { xs: "100%", sm: 420 },
          maxWidth: 700,
        }}
        ListboxProps={{
          onScroll: onOrgListScroll,
          style: { maxHeight: 280 },
        }}
        renderOption={(props, option) => {
          const { key, ...rest } = props;
          return (
            <li key={key} {...rest}>
              {formatOrganizationLabel(option)}
            </li>
          );
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Shop Id"
            size="small"
            required
            placeholder="Search shop name or Shop Id…"
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <>
                  {orgsLoadingMore ? (
                    <CircularProgress
                      color="inherit"
                      size={18}
                      sx={{ mr: 1 }}
                    />
                  ) : null}
                  {params.InputProps.endAdornment}
                </>
              ),
            }}
          />
        )}
      />
      <Button
        variant="outlined"
        onClick={onUploadCsv}
        disabled={uploadCsvDisabled}
        title={uploadCsvDisabled ? "Select a shop first" : undefined}
        sx={{ mt: 0.5, height: 40, flexShrink: 0, whiteSpace: "nowrap" }}
      >
        Upload CSV
      </Button>
      </Box>
    </Box>
  );
}
